<template>
    <header id="nav" class="app-header">
        <div class="flex justify-between">
            <h1>
                <button @click="goHome">
                    <svg xmlns="http://www.w3.org/2000/svg" width="242.666" height="47.959" viewBox="0 0 242.666 47.959">
                        <g transform="translate(-42.402 -21.539)">
                            <path id="Union_4" data-name="Union 4" d="M18413.525-9141l-3.309-10.076h-.615V-9141h-5.76v-25.918h11.232c1.586.578,2.811,1.586,2.811,4.322v5.5c0,2.482-1.008,3.564-2.412,4.179l3.1,8.279V-9141Zm-3.924-14.759h2.164l.359-.361v-5.759l-.359-.361h-2.164ZM18389.766-9141v-25.918h11.881v5.4h-6.121v4.683h5.76v5.4h-5.76v5.039h6.3v5.4Zm-6.295,0-3.314-10.076h-.609V-9141h-5.766v-25.918h11.232c1.586.578,2.811,1.586,2.811,4.322v5.5c0,2.482-1.006,3.564-2.412,4.179l3.1,8.279V-9141Zm-3.924-14.759h2.158l.361-.361v-5.759l-.361-.361h-2.158ZM18360.533-9141c-1.58-.573-2.8-1.581-2.8-4.317V-9162.6c0-2.736,1.225-3.744,2.8-4.322h8.428c1.586.578,2.807,1.586,2.807,4.322v17.278c0,2.736-1.221,3.744-2.807,4.317Zm2.955-20.879v15.841l.359.36h1.8l.361-.36v-15.841l-.361-.361h-1.8ZM18344.555-9141v-25.918h5.76v20.52h5.939v5.4Zm-15.7,0v-25.918h11.232c1.58.578,2.8,1.586,2.8,4.322v8.278c0,2.737-1.225,3.744-2.8,4.317h-5.475v9Zm5.758-13.678h2.16l.359-.36v-6.841l-.359-.361h-2.16ZM18321.8-9141l-1.623-9.249h-.359L18318.2-9141h-5.395v-4.354l2.77-8.6-2.77-8.607v-4.354h5.395l1.623,9.25h.359l1.623-9.25h5.395v4.354l-2.77,8.607,2.77,8.6V-9141Zm-22.719,0v-25.918h11.879v5.4h-6.119v4.683h5.758v5.4h-5.758v5.039h6.3v5.4Zm-13.031,0v-14.759h-.18l-1.8,5.759h-4.322l-1.8-5.759h-.176V-9141h-5.4v-25.918h6.3l3.061,9h.361l3.059-9h6.3V-9141Zm-20.736,0-.43-5.038h-2.736l-.436,5.038h-5.4v-4.354l3.277-21.563h7.844l3.277,21.563V-9141Zm-2.7-10.437h1.8l-.721-8.172h-.355Zm-12.24,10.438-3.314-10.076h-.611V-9141h-5.758v-25.918h11.232c1.58.578,2.8,1.586,2.8,4.322v5.5c0,2.482-1.008,3.564-2.408,4.179l3.092,8.279V-9141Zm-3.926-14.759h2.16l.359-.361v-5.759l-.359-.361h-2.16ZM18227.445-9141c-1.586-.573-2.807-1.581-2.807-4.317V-9162.6c0-2.736,1.221-3.744,2.807-4.322h8.422c1.584.578,2.811,1.586,2.811,4.322v4.317h-5.76v-3.6l-.361-.361h-1.8l-.355.361v15.841l.355.36h1.8l.361-.36v-4.678h-1.443v-5.4h7.2v10.8c0,2.736-1.227,3.744-2.811,4.317Zm-16.055,0c-1.586-.573-2.811-1.581-2.811-4.317V-9162.6c0-2.736,1.225-3.744,2.811-4.322h8.422c1.586.578,2.807,1.586,2.807,4.322v17.278c0,2.736-1.221,3.744-2.807,4.317Zm2.949-20.879v15.841l.361.36h1.8l.361-.36v-15.841l-.361-.361h-1.8ZM18202.279-9141l-3.309-10.076h-.615V-9141h-5.76v-25.918h11.232c1.586.578,2.811,1.586,2.811,4.322v5.5c0,2.482-1.008,3.564-2.412,4.179l3.092,8.279V-9141Zm-3.924-14.759h2.158l.365-.361v-5.759l-.365-.361h-2.158ZM18176.9-9141v-25.918h11.229c1.586.578,2.811,1.586,2.811,4.322v8.278c0,2.737-1.225,3.744-2.811,4.317h-5.469v9Zm5.76-13.678h2.158l.361-.36v-6.841l-.361-.361h-2.158Zm126.664-21.471c-.9-1.1-.957-2.792-.957-5.256s.057-4.16.957-5.256a3.369,3.369,0,0,1,2.811-1.3,3.366,3.366,0,0,1,2.807,1.3c.9,1.1.951,2.787.951,5.256s-.055,4.155-.951,5.256a3.366,3.366,0,0,1-2.807,1.294A3.369,3.369,0,0,1,18309.326-9176.15Zm1.941-9a11.735,11.735,0,0,0-.342,3.744,11.77,11.77,0,0,0,.342,3.744.892.892,0,0,0,.869.5.879.879,0,0,0,.859-.5,11.587,11.587,0,0,0,.344-3.744,11.553,11.553,0,0,0-.344-3.744.871.871,0,0,0-.859-.5A.883.883,0,0,0,18311.268-9185.15Zm-30.762,9c-.9-1.1-.953-2.792-.953-5.256s.057-4.16.953-5.256a3.369,3.369,0,0,1,2.811-1.3,3.32,3.32,0,0,1,2.463.92,4.14,4.14,0,0,1,1.156,2.861h-2.557a2.4,2.4,0,0,0-.2-.989.842.842,0,0,0-.863-.485.878.878,0,0,0-.865.5,11.735,11.735,0,0,0-.342,3.744,11.77,11.77,0,0,0,.342,3.744.886.886,0,0,0,.865.5.855.855,0,0,0,.863-.5,2.439,2.439,0,0,0,.2-.994h2.557a4.192,4.192,0,0,1-1.156,2.88,3.32,3.32,0,0,1-2.463.92A3.369,3.369,0,0,1,18280.506-9176.15Zm-8.746.23a3.528,3.528,0,0,1-.951-2.519v-9.379h2.551v9.31c0,.971.379,1.35,1.063,1.35s1.064-.379,1.064-1.35v-9.31h2.555v9.379a3.528,3.528,0,0,1-.951,2.519,3.582,3.582,0,0,1-2.668,1.063A3.578,3.578,0,0,1,18271.76-9175.92Zm-35.875-.23c-.9-1.1-.951-2.792-.951-5.256s.055-4.16.951-5.256a3.369,3.369,0,0,1,2.811-1.3,3.361,3.361,0,0,1,2.807,1.3c.9,1.1.951,2.787.951,5.256s-.051,4.155-.951,5.256a3.361,3.361,0,0,1-2.807,1.294A3.369,3.369,0,0,1,18235.885-9176.15Zm1.947-9a11.553,11.553,0,0,0-.344,3.744,11.587,11.587,0,0,0,.344,3.744.881.881,0,0,0,.863.5.89.89,0,0,0,.865-.5,11.77,11.77,0,0,0,.342-3.744,11.735,11.735,0,0,0-.342-3.744.881.881,0,0,0-.865-.5A.873.873,0,0,0,18237.832-9185.15Zm-36.148,9.23a3.529,3.529,0,0,1-.953-2.519v-9.379h2.557v9.31c0,.971.379,1.35,1.064,1.35s1.063-.379,1.063-1.35v-9.31h2.557v9.379a3.507,3.507,0,0,1-.957,2.519,3.578,3.578,0,0,1-2.662,1.063A3.582,3.582,0,0,1,18201.684-9175.92Zm-8.82-.23c-.9-1.1-.951-2.792-.951-5.256s.055-4.16.951-5.256a3.369,3.369,0,0,1,2.811-1.3,3.34,3.34,0,0,1,2.469.92,4.137,4.137,0,0,1,1.15,2.861h-2.555a2.463,2.463,0,0,0-.2-.989.847.847,0,0,0-.865-.485.869.869,0,0,0-.863.5,11.735,11.735,0,0,0-.342,3.744,11.77,11.77,0,0,0,.342,3.744.877.877,0,0,0,.863.5.86.86,0,0,0,.865-.5,2.505,2.505,0,0,0,.2-.994h2.555a4.189,4.189,0,0,1-1.15,2.88,3.34,3.34,0,0,1-2.469.92A3.369,3.369,0,0,1,18192.863-9176.15Zm129.91,1.15-2.719-6.264V-9175h-2.555v-12.817h2.232l2.662,6.268v-6.268h2.557V-9175Zm-18.559,0v-12.817h2.555V-9175Zm-6.064,0v-10.512h-2.164v-2.306h6.879v2.306h-2.164V-9175Zm-4.4,0-.412-2h-2.953l-.412,2h-2.662l3.291-12.817h2.52l3.295,12.817Zm-2.875-4.3h1.979l-.994-4.751Zm-28.965,4.3v-12.817h3.619a3.415,3.415,0,0,1,2.807,1.243c.9,1.026.957,2.792.957,5.149s-.057,4.155-.957,5.182a3.415,3.415,0,0,1-2.807,1.243Zm2.557-2.3h1.008a1.013,1.013,0,0,0,.951-.56,10.964,10.964,0,0,0,.311-3.563,10.693,10.693,0,0,0-.311-3.527,1.007,1.007,0,0,0-.951-.56h-1.008Zm-10.027,2.3v-12.817h5.9v2.306H18257v2.844h2.881v2.3H18257v3.064h3.348v2.3Zm-10.387,0v-12.817h5.908v2.306h-3.352v2.9h2.881v2.3h-2.881V-9175Zm-17.943,0v-4.825l-2.611-7.992h2.811l1.076,4.646,1.082-4.646h2.807l-2.607,7.992V-9175Zm-8.3,0v-10.512h-2.164v-2.306h6.879v2.306h-2.164V-9175Zm-7.961,0v-12.817h2.557v10.516h3.352v2.3Zm-21.055,0-.416-2h-2.953l-.412,2h-2.668l3.3-12.817h2.52l3.295,12.817Zm-2.885-4.3h1.982l-.988-4.751Zm-8.926,4.3v-12.817h5.9v2.306h-3.346v2.9h2.879v2.3h-2.879V-9175Z" transform="translate(-18134 9210)" :fill="logoFill"/>
                        </g>
                    </svg>
                </button>
            </h1>

            <button @click="restart" class="button reset-button">
                Reset
            </button>
        </div>
    </header>
</template>

<script>
    import { mapMutations } from "vuex";
    export default {
        name: "Header",
        methods: {
            ...mapMutations([
                'resetResults'
            ]),

            restart() {
                this.resetResults();
                if( this.$route.path !== '/pathway/0') {
                    this.$router.push("/pathway/0");
                }
            },

            goHome() {
                this.resetResults();
                this.$router.push("/");
            },
        },
        computed: {
            logoFill() {
                // return this.$route.path == '/results' ? '#A6192E' : '#fff';
                return '#fff';
            }
        }
    };
</script>

<style scoped>

    small {
        display: block;
        font-size: 65%;
        margin-bottom: 1rem;
        font-weight: normal;
    }

    .app-header {
        font-family: "countach-bold";
        background: var(--c-red);
        color: #fff;
        margin: 0;
        padding: 1rem 0.5rem;
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 100;
    }

    @media (min-width: 900px) {
        .app-header {
            padding: 1rem 1rem;
        }
    }

    .app-header .flex {
        width: 100%;
    }

    .app-header h1 {
        color: #fff;
        margin: 0;
        padding: 0;
        font-size: 12px;
        text-transform: uppercase;
        text-align: left;
        max-width: ;
    }

    .app-header span {
        display: block;
        font-size: 36px;
        font-weight: bold;
    }

    .app-header h1 button {
        text-decoration: none;
        text-align: left;
        width: 200px;
    }

    .app-header button {
        color: #fff;
        text-transform: uppercase;
        appearance: none;
        background: none;
        border: none;
        text-decoration: underline;
        cursor: pointer;
        font-family: "countach-bold";

    }

    @media (min-width: 900px) {
        .app-header h1 button {
            width: 300px;
        }
    }

    .app-header h1 button svg {
        width: 100%;
    }

    button.reset-button {
        font-size: 18px;
        position: relative;
        /* z-index: 100; */
        font-weight: bold;
        font-family: var(--font-pdf);
    }

    button.reset-button:hover,
    button.reset-button:focus {
        text-decoration: none;
    }

</style>
